<div class="calendar" [class.calendar--custom-nav]="!useNativeNavigation">
  <div class="custom-nav" *ngIf="!useNativeNavigation">
    <div class="custom-nav__selects">
      <app-dropdown-input
        class="custom-nav__month"
        menuClass="date-picker-nav-menu"
        [dropdowns]="monthOptions"
        [ngModel]="viewDate.month"
        [ngModelOptions]="{ standalone: true }"
        (selection)="onMonthSelected(datepicker, $event)" />
      <app-dropdown-input
        class="custom-nav__year"
        menuClass="date-picker-nav-menu"
        [dropdowns]="yearOptions"
        [ngModel]="viewDate.year"
        [ngModelOptions]="{ standalone: true }"
        (selection)="onYearSelected(datepicker, $event)" />
    </div>

    <div class="custom-nav__arrows">
      <button
        type="button"
        class="custom-nav__arrow"
        i18n-aria-label
        aria-label="Previous month"
        [disabled]="!canGoToPreviousMonth"
        (click)="navigate(datepicker, -1)">
        <img class="custom-nav__chevron" src="assets/icons/grey/Chevron Up.svg" alt="" aria-hidden="true" />
      </button>
      <button
        type="button"
        class="custom-nav__arrow"
        i18n-aria-label
        aria-label="Next month"
        [disabled]="!canGoToNextMonth"
        (click)="navigate(datepicker, 1)">
        <img class="custom-nav__chevron" src="assets/icons/grey/Chevron Down.svg" alt="" aria-hidden="true" />
      </button>
    </div>
  </div>

  <ngb-datepicker
    #datepicker
    class="date-picker"
    (dateSelect)="handleDateSelection($event)"
    (navigate)="onDatepickerNavigate($event)"
    [navigation]="navigationMode"
    [displayMonths]="1"
    [dayTemplate]="t"
    [footerTemplate]="f"
    [minDate]="minNgbDate"
    [maxDate]="maxNgbDate"
    outsideDays="hidden"
    [startDate]="fromDate!"
    tabindex="-1" />
</div>

<ng-template #t let-date let-focused="focused">
  <span
    class="custom-day"
    [class.focused]="isFocused(date, focused)"
    [class.range]="isRange(date)"
    [class.faded]="isHovered(date) || isInside(date)"
    (mouseenter)="hoveredDate = date"
    (mouseleave)="hoveredDate = null">
    {{ date.day }}
  </span>
</ng-template>

<ng-template #f>
  <div class="action-buttons">
    <button type="button" i18n (click)="clear()">Reset</button>
    <button type="button" i18n (click)="emitDateSelection()">Confirm</button>
  </div>
</ng-template>
